import React from 'react';
import { Banner } from '@shopify/polaris';

const PREFIX = 'satcb.banner.dismissed.';

function getKey(key) {
  return `${PREFIX}${key}`;
}

function isBannerDismissed(key) {
  try {
    return sessionStorage.getItem(getKey(key)) === '1';
  } catch (e) {
    return false;
  }
}

function dismissBanner(key) {
  try {
    sessionStorage.setItem(getKey(key), '1');
  } catch (e) {
    // ignore
  }
}

// Keep this as a class so you can force a rerender via local state tick
export class GlobalPlanBanners extends React.Component {
  constructor(props) {
    super(props);
    this.state = { tick: 0 };
  }

  bump = () => this.setState((p) => ({ tick: (p.tick || 0) + 1 }));

  openPlans = () => {
    const { url } = this.props;

    const params = new URLSearchParams(url || window.location.search);
    const shop = params.get('shop');
    const host = params.get('host');

    // keep your existing behavior
    window.open('/plans?shop=' + shop + '&host=' + host, '_self');
  };

  render() {
    const { common } = this.props;
    if (!common) return null;

    const hasFreePlanActivated = !!common.hasFreePlanActivated;
    const freePlanClicksUsed = Number(common.freePlanClicksUsed || 0);
    const resetDate = common.freePlanCreditsResetDate;

    const showLimitReached = hasFreePlanActivated && freePlanClicksUsed <= 0;
    const showUsage = hasFreePlanActivated && freePlanClicksUsed > 0;

    return (
      <>
        {showLimitReached && !isBannerDismissed('App.PlanLimitReached') && (
          <Banner
            title={`Free plan usage Limit Reached: App Paused Until ${new Date(resetDate).toLocaleString(undefined, {
              year: 'numeric',
              month: '2-digit',
              day: '2-digit',
              hour: '2-digit',
              minute: '2-digit',
            })}`}
            status="critical"
            action={{ content: 'Upgrade now', onAction: this.openPlans }}
            onDismiss={() => {
              dismissBanner('App.PlanLimitReached');
              this.bump();
            }}
          >
            <p>
              Your store is currently on the Free plan whose limit is reached and the STKTY app is paused until your next
              30-day cycle. Upgrade your plan now to avoid disruptions.
            </p>
          </Banner>
        )}

        {showUsage && !isBannerDismissed('App.FreePlanUsage') && (
          <Banner
            title={`Free plan usage: ${freePlanClicksUsed >= 0 ? freePlanClicksUsed : 0} clicks left out of 25`}
            status="warning"
            action={{ content: 'View plans', onAction: this.openPlans }}
            onDismiss={() => {
              dismissBanner('App.FreePlanUsage');
              this.bump();
            }}
          >
            <p>
              Your store is currently on the Free plan. Once 25 clicks are reached, all STKY widgets will be paused until
              your next 30-day cycle begins on {` ${new Date(resetDate).toLocaleString(undefined, {
              year: 'numeric',
              month: '2-digit',
              day: '2-digit',
              hour: '2-digit',
              minute: '2-digit',
            })}`}
               . Upgrade your plan today to avoid disruptions.
            </p>
          </Banner>
        )}
      </>
    );
  }
}